import { v4 as uuid } from 'uuid';
import { EXCLUDE_PILL } from '../../../types/pills';
import './NudosProductPills.scss';

const NudosProductPills = ({
  pills,
  characterLimit = 14,
  isLoading = false,
  customHeight,
  xPadding,
  yPadding,
  customLineHeigth
}: {
  pills: { [key: string]: string | null | undefined };
  characterLimit?: number;
  isLoading?: boolean;
  customHeight?: number;
  xPadding?: string;
  yPadding?: string;
  customLineHeigth?: string;
}) => {
  const profileAndLinePills = Object.values(EXCLUDE_PILL) as EXCLUDE_PILL[];
  const excludeWidthAndLength: EXCLUDE_PILL[] = profileAndLinePills.filter(
    props => props !== EXCLUDE_PILL.Ancho && props !== EXCLUDE_PILL.Largo
  );
  const pillsArr = pills ? Object.entries(pills).filter(([key]) => !key?.includes(EXCLUDE_PILL.Perfil)) : [];
  const specsPills = pillsArr
    .filter(([key, value]) => value && key && !excludeWidthAndLength.includes(key as EXCLUDE_PILL))
    .slice(0, 3);
  return (
    <>
      {isLoading && <ProductPillsSkeletonLoader />}
      {!isLoading && (
        <div className="productPills" style={{ height: customHeight ? `${customHeight}px` : '' }}>
          {specsPills &&
            specsPills.length > 0 &&
            specsPills.map(([key, value]) => {
              return (
                <div
                  key={uuid()}
                  className="pill technicalDetail"
                  style={{ height: customHeight ? `${customHeight}px` : '' }}
                >
                  <p
                    className="pillText"
                    style={{
                      height: customHeight ? `${customHeight}px` : '',
                      paddingTop: xPadding || '',
                      paddingBottom: xPadding || '',
                      paddingLeft: yPadding || '',
                      paddingRight: yPadding || '',
                      lineHeight: customLineHeigth || ''
                    }}
                  >
                    {value && value.length > characterLimit ? `${value?.slice(0, characterLimit)}...` : value}
                  </p>
                  <div className="hoverContainer">
                    <div className="hoverKey">{key ? key : 'Propiedad'}:</div>
                    <div className="hoverValue">{value ? value : 'Valor'}</div>
                  </div>
                </div>
              );
            })}
        </div>
      )}
    </>
  );
};

export default NudosProductPills;

const ProductPillsSkeletonLoader = () => {
  return (
    <div className="productPillsSkeletonLoader">
      {[0, 1, 2].map(pill => {
        return <div key={`pill${pill}`} className="pill animationLoader" />;
      })}
    </div>
  );
};
